import {
  GeneralReportsParams,
  MonthlySalesReportsParams,
  ReasonDenialReportsParams,
  ReportsParams,
  SalesByStoreReportsParams
} from "@repo/core/services/entities/Reports";
import { ReportsResponse } from "@repo/core/types/reports";
import { AxiosInstance, AxiosResponse } from "axios";

const resourcePrefixNewApi = "/reports";

export class ReportsResource {
  apiProvider: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async getGeneralReports(
    params: GeneralReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(`${resourcePrefixNewApi}/general`, {
      params
    });
  }

  async getAnalysedProposalsReports(
    params: ReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(
      `${resourcePrefixNewApi}/proposals/proposal-analyzed`,
      {
        params
      }
    );
  }

  async getApprovalTypesReports(
    params: ReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(
      `${resourcePrefixNewApi}/proposals/type-approval`,
      { params }
    );
  }

  async getAttendantsReports(
    params: ReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(
      `${resourcePrefixNewApi}/proposals/attendant-report`,
      {
        params
      }
    );
  }

  async getReasonDenialReports(
    params: ReasonDenialReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(
      `${resourcePrefixNewApi}/proposals/reason-denial`,
      {
        params
      }
    );
  }

  async getOverdueWalletReports(
    params: ReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(
      `${resourcePrefixNewApi}/sales/overdue-wallet`,
      {
        params
      }
    );
  }

  async getMonthlySalesReports(
    params: MonthlySalesReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(
      `${resourcePrefixNewApi}/sales/monthly-transactions`,
      {
        params
      }
    );
  }

  async getSalesByStoreReports(
    params: SalesByStoreReportsParams
  ): Promise<AxiosResponse<ReportsResponse>> {
    return this.apiProvider.get(
      `${resourcePrefixNewApi}/sales/point-sale-transaction`,
      {
        params
      }
    );
  }
}
